export class CallCenterComparativoTrimestralProduto {
  constructor(
    public produto: string,
    public valor_recente: number,
    public valor_anterior: number,
    public variacao_percentual: number
  ) { }
}
